import { apiCallWrapper } from 'traveldesk-ui'
import { SelectOptionModel } from 'traveldesk-ui'
import City from '../models/City'

export default class CitiesApiService {
    public static async getCitiesOptions(dispatch: any, countryId: number | undefined = undefined) {
        let url = '/api/cities/options'
        if (countryId) {
            url += `?countryId=${countryId}`
        }
        return await apiCallWrapper<SelectOptionModel[]>(url, 'GET', dispatch)
    }
    public static async getCitiesInSuppliersCountry(dispatch: any) {
        const res = await apiCallWrapper<SelectOptionModel[]>('/api/cities/supplier', 'GET', dispatch)
        return res
    }
 

   public static async GetCitiesOfOperation(dispatch: any) {
        const res = await apiCallWrapper<City[]>('/api/suppliers/cities', 'GET', dispatch)
        return res
    }
}